import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-816489f8"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "task-type-dropdown__selected-content"
}
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "task-type-dropdown__type" }
const _hoisted_4 = { class: "task-type-dropdown__option__description" }

import { computed, PropType } from 'vue';
import {
  TirPmDropdownSizeEnum,
  TirPmPopover,
  PopoverPositionEnum,
  TirPmTooltipElement,
  TirPmDropdown,
} from 'tir-components';
import { TypeModel } from '../../models';
import { TypeDropdownOptionModel } from './models';
import { InformationCircleIcon } from 'tir-style-system/icons/outline';
import { TirPmDropdownVariantEnum } from 'tir-pm-dropdown/src/enums';


export default /*#__PURE__*/_defineComponent({
  __name: 'task-type-dropdown',
  props: {
  /**Возможность редактировать */
  editing: {
    type: Boolean as PropType<boolean>,
    default: true,
  },
  /**Выбранный тип */
  modelValue: {
    type: String,
  },
  /**Типы для выбора */
  options: {
    type: Array as PropType<Array<TypeModel>>,
    default: [],
  },
},
  emits: ["update:modelValue"],
  setup(__props, { emit }) {

const props = __props;





/**Опции дропдауна */
const dropdownOptions = computed(() =>
  props.options.map(
    (option) =>
      new TypeDropdownOptionModel({
        Id: option.Id,
        Name: option.Name,
        Color: option.Color,
        Description: option.Description,
      }),
  ),
);

/**Выбранная опция */
const selectedOption = computed(() =>
  props.modelValue !== undefined
    ? dropdownOptions.value.find((option) => props.modelValue === option.Id)
    : undefined,
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(TirPmDropdown), {
    variant: _unref(TirPmDropdownVariantEnum).Detached,
    class: "task-type-dropdown",
    label: "Тип",
    placeholder: "Выберите тип",
    options: dropdownOptions.value,
    "selected-option": selectedOption.value,
    size: _unref(TirPmDropdownSizeEnum).Light,
    width: "fit-content",
    "is-disabled-popover": (__props.options.length <= 1 && !!__props.modelValue) || !__props.editing,
    isDisabled: !__props.editing,
    "popover-width": "auto"
  }, {
    selectedContent: _withCtx(() => [
      (selectedOption.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(selectedOption.value.Name), 1))
        : _createCommentVNode("", true)
    ]),
    optionList: _withCtx(({ option }) => [
      _createElementVNode("div", {
        class: "task-type-dropdown__option",
        onClick: ($event: any) => (emit('update:modelValue', option.Id))
      }, [
        _createElementVNode("div", _hoisted_3, _toDisplayString(option.Name), 1),
        (option.Description)
          ? (_openBlock(), _createBlock(_unref(TirPmTooltipElement), {
              key: 0,
              width: "15rem"
            }, {
              content: _withCtx(() => [
                _createElementVNode("div", _hoisted_4, _toDisplayString(option.Description), 1)
              ]),
              default: _withCtx(() => [
                _createVNode(_unref(InformationCircleIcon), { class: "task-type-dropdown__option__icon" })
              ]),
              _: 2
            }, 1024))
          : _createCommentVNode("", true)
      ], 8, _hoisted_2)
    ]),
    _: 1
  }, 8, ["variant", "options", "selected-option", "size", "is-disabled-popover", "isDisabled"]))
}
}

})